import moment from 'moment'
import config from '@/config'

export const dateAsReadable = (value) => moment(value).format(config.dateFormat.client)
export const stringToMoment = (dateAsString, pattern = config.dateFormat.client) => moment(dateAsString, pattern)
export const hasCompleteYear = (dateValue) => moment(dateValue, moment.ISO_8601).year() >= 1000
